import LZString from "lz-string";

/**
 * "Spy View" mode. When the page is opened with a `#spy=<data>` fragment, the
 * grimoire is rendered read-only from the state encoded in that fragment instead
 * of from localStorage (see store.js, which consumes `spyData`). The fragment is
 * a lz-string-compressed JSON snapshot of { characters, tokens, height } created
 * by processes/grimoire/spy-view.js.
 *
 * Using the fragment (not a query string) keeps the snapshot client-side: it is
 * never sent to CloudFront and isn't subject to URL-length limits at the CDN.
 */
function decodeSpy() {

    const match = (window.location.hash || "").match(/[#&]spy=([^&]+)/);

    if (!match) {
        return null;
    }

    let decoded;

    try {
        decoded = JSON.parse(LZString.decompressFromEncodedURIComponent(match[1]));
    } catch (ignore) {
        return null;
    }

    if (!decoded || typeof decoded !== "object") {
        return null;
    }

    // Expand the compact tokens (see spy-view.js) back to the full store shape.
    const tokens = (Array.isArray(decoded.k) ? decoded.k : []).map((t) => ({
        id: t.i,
        left: t.l,
        top: t.t,
        zIndex: t.z,
        isDead: Boolean(t.d),
        isUpsideDown: Boolean(t.u),
        ghostVote: Boolean(t.g),
        playerName: t.n || ""
    }));

    // Pad out to the full store shape so store.js's rehydration loop (which reads
    // bluffs/inputs/details/infoTokens too) works unchanged.
    return {
        characters: decoded.c || {},
        tokens,
        bluffs: decoded.b || {},
        height: decoded.h || "",
        inputs: {},
        details: {},
        infoTokens: []
    };

}

/**
 * The decoded spy snapshot, or null when not in spy mode.
 * @type {Object|null}
 */
export const spyData = decodeSpy();

if (spyData) {

    document.body.classList.add("body-spy");

    // The grimoire is a <details>; force it open so the pad is visible.
    const grimoire = document.getElementById("grimoire");

    if (grimoire) {
        grimoire.open = true;
    }

}
